// Loading spinner. `full` centers it in a full-screen container.
export default function Spinner({ full = false }) {
  const ring = (
    <span className="h-6 w-6 animate-spin rounded-full border-2 border-line border-t-accent" />
  );
  if (full) {
    return <div className="flex min-h-full items-center justify-center bg-background">{ring}</div>;
  }
  return ring;
}
